export default __webpack_public_path__ + "static/SR France - Ingredient & Label - Burnt Sugars - Statement-9c41a10eb55157119277f2c79bd3ab88.pdf";